import type { Timesheets, Slots } from './types/timesheet';
import axios from 'axios';

interface AmendTimesheetRequestPayload {
  intTimesheetId?: number;
  strStartTime?: string;
  strEndTime?: string;
  arrSlots?: Slots[];
  intOpunitId?: number;
  arrCustomFieldData?: Record<string, string>;
  strEmployeeComment?: string;
}

export async function postTimesheetAmend(
  payload: AmendTimesheetRequestPayload,
  authorization: string
): Promise<Timesheets> {
  const response = await axios.post('/api/v1/my/timesheet/ipamend', payload, {
    headers: {
      Authorization: authorization,
    },
  });
  return response?.data;
}
